import React ,{useEffect}from 'react'
import { useNavigate } from 'react-router-dom';
import axios from '../../../../utils/apidsf.js'

// icons

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import swal from 'sweetalert'
import LogoImg from '../../../../image/lexpedia-logo.jpg'


// css
import './TopBar.css'

const TopBar = () => {
  const navigate =useNavigate()

  useEffect(async()=>{
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    await axios.get('/auth/me' ,config)
    .then((res)=>{
      console.log(res?.data)
      if(res?.data?.success){

      }else{
        navigate('/')
      }

    }).catch((err)=>{
      console.log(err)
      navigate('/')
    })


  },[])
  return (
    <div className="topbar">
      <div className="topbar__wrapper">
        <div className="topleft">
          <span className="topbar__logo">
            {" "}
            <img className='sitelogo' src={LogoImg} />
          </span>
        </div>
        <div className="topright">
          {/* <div className="topbar__icon_container">
            <NotificationsNoneIcon />{" "}
            <span className="topbar__iconbadge">0</span>
          </div> */}
          <div className="topbar__icon_container" onClick={() => {
            swal({
              title: "Are you sure?",
              text: "Are You Want To logOut",
              icon: "warning",
              buttons: true,
            }).then((willDelete) => {
              if (willDelete) {
                localStorage.setItem('token', '')
                navigate('/')
                
              } else {
                
              }
            });
          }}>
            <LogoutIcon /> 
          </div>
         
        </div>
      </div>
    </div>
  );
}

export default TopBar
